import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Render işlemini burada yapar.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
